<app-form-shell [title]="'Nueva cita'" [mode]="mode" (close)="onCancel()">
  <form [formGroup]="form" class="appointment-form container-fluid">

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Cliente</mat-label>
      <input type="text" matInput [formControl]="contactCtrl" [matAutocomplete]="auto"
        placeholder="Buscar o crear cliente..." />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayContact">
        <mat-option *ngFor="let c of filteredContacts; trackBy: trackByIndex" [value]="c">
          {{ c.companyName }}
        </mat-option>

        <mat-option *ngIf="allowNewContact" [value]="createContactOption" class="text-primary fw-bold">
          + Crear cliente: {{ createContactOption.companyName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <div class="mb-3">
      <app-select class="w-100" [formControl]="form.get('conceptUid')"
        [config]="{ label: 'Servicio', options: conceptsOptions }">
      </app-select>
    </div>

    <div class="mb-3">
      <app-select class="w-100" [formControl]="form.get('employeeId')"
        [config]="{ label: 'Empleado', options: employeesOptions }">
      </app-select>
    </div>

    <div class="row">
      <div class="col-md-4 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fecha</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="date" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-md-4 mb-3">
        <app-input inputType="time" placeholder="Inicio" class="w-100" [formControl]="form.get('startTime')"></app-input>
      </div>

      <div class="col-md-4 mb-3">
        <app-input inputType="time" placeholder="Fin" class="w-100" [formControl]="form.get('endTime')"></app-input>
      </div>
    </div>

    <div class="mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Notas</mat-label>
        <textarea matInput formControlName="notes" rows="3" placeholder="Añade observaciones..."></textarea>
      </mat-form-field>
    </div>
  </form>

  <div class="footer-actions d-flex justify-content-end gap-2 border-top pt-3 mt-3 bg-white">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="onSave()" [disabled]="form.invalid">
      Guardar
    </button>
  </div>
</app-form-shell>